import { useKontaCallsStore } from 'dashboard/stores/kontaCalls';

export const KONTA_VOICE_CONTENT_TYPE = 'konta_voice_call';

export const KONTA_TERMINAL_STATUSES = ['completed', 'no_answer', 'failed'];

export const isInbound = direction => direction === 'inbound';

const isKontaVoiceCallMessage = message =>
  message?.content_type === KONTA_VOICE_CONTENT_TYPE;

const shouldSkipCall = (callDirection, senderId, currentUserId) =>
  callDirection === 'outbound' && senderId !== currentUserId;

function extractCallData(message) {
  const contentData = message?.content_attributes?.data || {};
  return {
    callSid: contentData.call_sid,
    status: contentData.status,
    callDirection: contentData.call_direction,
    room: contentData.room,
    conversationId: message?.conversation_id,
    senderId: message?.sender?.id,
    inboxId: contentData.inbox_id || message?.inbox_id,
    fromNumber: contentData.from_number,
    contactName: contentData.contact_name,
    acceptedByAgentId: contentData.accepted_by_agent_id,
  };
}

export function handleKontaVoiceCallCreated(message, currentUserId) {
  if (!isKontaVoiceCallMessage(message)) return;

  const {
    callSid,
    callDirection,
    conversationId,
    senderId,
    inboxId,
    fromNumber,
    contactName,
  } = extractCallData(message);

  if (shouldSkipCall(callDirection, senderId, currentUserId)) return;

  const kontaCallsStore = useKontaCallsStore();
  kontaCallsStore.addCall({
    callSid,
    conversationId,
    callDirection,
    senderId,
    inboxId,
    fromNumber,
    contactName,
  });
}

export function handleKontaVoiceCallUpdated(message, currentUserId) {
  if (!isKontaVoiceCallMessage(message)) return;

  const {
    callSid,
    status,
    callDirection,
    conversationId,
    senderId,
    inboxId,
    fromNumber,
    contactName,
    acceptedByAgentId,
  } = extractCallData(message);

  const kontaCallsStore = useKontaCallsStore();
  kontaCallsStore.handleCallStatusChanged({ callSid, status, conversationId });

  // An agent claimed the call: clear the incoming banner in every non-answering window. Pass the
  // ids so the store keeps the answering window by identity, not by the transient isActive flag.
  if (acceptedByAgentId) {
    kontaCallsStore.handleCallAnswered({
      callSid,
      conversationId,
      acceptedByAgentId,
      currentUserId,
    });
  }

  // acceptedByAgentId also blocks re-adding: the claim stamp arrives with status still
  // 'ringing' and must not resurrect the banner it just cleared.
  const isNewCall =
    status === 'ringing' &&
    !acceptedByAgentId &&
    !shouldSkipCall(callDirection, senderId, currentUserId);

  if (isNewCall) {
    kontaCallsStore.addCall({
      callSid,
      conversationId,
      callDirection,
      senderId,
      inboxId,
      fromNumber,
      contactName,
    });
  }
}
